import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  // QuestionForm
  formContainer: {
    margin: 10,
  },
  buttonsBlock: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 10,
  },
  leftButton: {
    marginRight: 10,
  },
  formItem: {
    marginBottom: 12,
  },
  formLabel: {},
  cardContainer: {
    marginTop: 10,
    borderRadius: 10,
  },
  dateText: {
    textAlign: 'start',
    fontSize: 12,
    paddingRight: 8,
  },
  mergeContainer: {
    display: 'flex',
  },
  twoColumnsField: {
    width: '50%',
    margin: '4px 0px 15px -1px',
  },
});
